var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { color: "white" }, attrs: { id: "turn-tool-button" } },
    [
      _c("div", { on: { click: _vm.componentClick } }, [
        _c("img", {
          ref: "turnToolButtonImage",
          class: _vm.current,
          attrs: { src: _vm.imageSrc, alt: "Turn" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }